<template>
	<div>
		<div class="title">
			<div id="notice">
				<h5>物品基础信息&nbsp;&nbsp;说明:</h5><br>
				<span>1、资料信息共用,不分归属。可以提前设置标准明细,供做相关业务单据使用时调用。</span><br>
				<span class="red">2、查询关键字:名称、编号、分类、供应商</span><br>
			</div>
		</div>
		<!-- 主+明细 -->
		<pre-base ref="mybase" @base2-event="refresh_father" :pre_data="init_data">
			<template slot="pre_base_button">
				<button @click="edit_mode">引入模板</button>
			</template>

		</pre-base>

		<editmode-tan ref="itemmode"></editmode-tan>

	</div>
</template>

<script>
	import {
		GetShort
	} from '@/utils/localstore.js';

	export default {
		components: {
			"pre-base": () => import("../auto/auto_view.vue"),
			'editmode-tan': () => import("./tan_editmode.vue")
		},
		data() {
			return {
				init_data: '',
				row_id: '',
				item: '',

				// 组件
				show_tan: '0',
				show_item: ''
			};
		},
		mounted: function() {
			var that = this;
			this.$nextTick(function() {
				that.fun_init();
			});
		},
		methods: {
			fun_init: function() {
				// let udata = GetShort('userdata');
				// let rname = '';
				// if (typeof(udata) !== 'undefined' && udata != '') {
				// 	let r = JSON.parse(udata);
				// 	rname = r[0].rname;
				// }
				// console.log('当前角色:' + rname);

				this.init_data = '';

				this.init_data = JSON.stringify({
					"control": "caritembase",
					"title": "物品资料名称",
					"isTwo": "0",
					"isTwoDetail": "0",
					"action_flag": "",
					"isFileMain": "1",
					"step": "0",
					"sel_action": 'exp_store_car_itembase',
					"upd_action": 'exp15_store_car_itembase',
					"tab_name_1": "",
					"tab_name_2": "",
					"detail_part": "0",
					"detail_excelup": "0",
					"d_btn_more": "0",
					"d_sel_action": '',
					"d_upd_action": '',
					"file_action": '',
					"p1": '',
					"p2": '',
					"p3": '',
					"parm_sel": [{
							"name": "系统编号",
							"val": "",
							"key": "sheet_no",
							"type": "text",
							"class": "long1"
						}, {
							"name": "商品名称",
							"val": "",
							"key": "item_name",
							"type": "text",
							"class": "long1",
						},
						{
							"name": "类别",
							"val": "",
							"key": "item_class",
							"type": "select",
							"class": "long1",
							"sel_action": "_base_itemclass",
							"sel_name": ""
						},
						{
							"name": "供应商",
							"val": "",
							"key": "item_from",
							"type": "select",
							"class": "long1",
							"sel_action": "_base_itemfrom",
							"sel_name": ""
						}
					],
					"parm": [{
							"name": "系统编号",
							"val": "",
							"key": "sheet_no",
							"type": "text",
							"class": "long1",
							"p": "1",
							"w": "0",
							"r": "1",
							"x": "1"
						},
						{
							"name": "名称",
							"val": "",
							"key": "item_name",
							"type": "text",
							"class": "long1",
							"p": "1",
							"w": "1",
							"r": "0",
							"x": "1"
						},
						{
							"name": "国际条码",
							"val": "",
							"key": "item_contry",
							"type": "text",
							"class": "long2",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "1"
						},
						{
							"name": "类别",
							"val": "",
							"key": "class_id",
							"type": "select",
							"class": "long1",
							"sel_action": "_base_itemclass",
							"sel_name": "",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "2"
						},
						{
							"name": "单位",
							"val": "",
							"key": "unit_id",
							"type": "select",
							"class": "long1",
							"sel_action": "_base_itemunit",
							"sel_name": "",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "2"
						},
						{
							"name": "规格",
							"val": "",
							"key": "size",
							"type": "text",
							"class": "long1",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "2"
						},
						{
							"name": "重量",
							"val": "",
							"key": "item_weight",
							"type": "number",
							"class": "long1",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "2"
						},
						{
							"name": "价格",
							"val": "",
							"key": "item_price",
							"type": "number",
							"class": "long1",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "3"
						},
						{
							"name": "供货商",
							"val": "",
							"key": "f_name",
							"type": "select",
							"sel_action": "_base_itemfrom",
							"sel_name": "",
							"class": "long1",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "3"
						},
						{
							"name": "备注",
							"val": "",
							"key": "note",
							"type": "text",
							"class": "long4",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "4"
						}
					],
					"parm_th": [
						{
							"name": "序号"
						},
						{
							"name": "商品编号"
						},
						// {
						//   "name": "主图"
						// },
						{
							"name": "商品名称"
						},
						{
							"name": "类型"
						},
						{
							"name": "单位"
						},
						{
							"name": "商品条码"
						},
						{
							"name": "规格"
						},
						{
							"name": "重量"
						},
						{
							"name": "价格"
						},
						{
							"name": "供货商"
						},
						{
							"name": "详情"
						},
						{
							"name": "备注"
						},
						{
							"name": "状态"
						},
						{
							"name": "修改人"
						},
						{
							"name": "更新时间"
						}
					],
					"d_parm": [],
					"d_name": [],

				});


			},
			refresh_data: function() {

				var that = this;
				this.$nextTick(function() {
					that.$refs['mybase'].refresh_data('1');
				});
			},
			refresh_father: function(type, val, parm) {
				switch (type) {
					case 'father':
						// 弹出修改明细，修改主窗口信息
						// this.refresh_data();
						break;
					default:
						// console.log('子组件刷新父组件传值=' + val);
						this.row_id = val;
						this.item = parm;
						break;
				}
			},
			edit_mode: function() {

				this.$refs.itemmode.showpop();
			},



		}
	};
</script>
<style>
</style>
